//机构管理
import {
  ORGANIZATION,
  API
} from './api'
import {
  METHOD,
  request
} from '@/utils/request'

export function queryAllOrganizations(params) {
  return request(ORGANIZATION + "/queryAllOrganizations", METHOD.GET, params)
}

export function saveOrganization(params) {
  return request(ORGANIZATION + "/insertOneOrganization", METHOD.POST, params)
}

export function updateOrganization(params) {
  return request(ORGANIZATION + "/updateOneOrganizationById", METHOD.POST, params)
}

export function delOrganization(params) {
  return request(ORGANIZATION + "/deleteOneOrganizationById", METHOD.DELETE, params)
}

/**
 * 学院列表
 * @returns 
 */
 export function listCollege(){
  return request(ORGANIZATION+'/getCollegeList', METHOD.GET)
}

/**
 * 学院专业列表
 * @param {*} orgCode 
 * @returns 
 */
export function listMajorDic(orgCode){
  return request(API+'/major/getMajorDic', METHOD.GET, {orgCode})
}

export default {
  queryAllOrganizations,
  saveOrganization,
  updateOrganization,
  delOrganization
}